export function changeFormatPrice(price) {
    return new Intl.NumberFormat('ja-JP').format(price);
  }
window.changeFormatPrice = changeFormatPrice;